// ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Ensure this path is correct

function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();
    if (!user) {
        // Redirects to the login page while preserving the intended destination
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}

export default ProtectedRoute;
